import { v4 as uuidv4 } from "uuid";
import {
    generateNewChoice,
    questionsDefault,
    generateDefaultPage,
    generateSurveyTemplate,
} from "../../surveys";

const pages = [
    {
        ...generateDefaultPage(),
        questions: [
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "When was the last time you used this product category?",
                choices: [
                    generateNewChoice("In the last week"),
                    generateNewChoice("In the last month"),
                    generateNewChoice("In the last 3 months"),
                    generateNewChoice("In the last 6 months"),
                    generateNewChoice("In the last 12 months"),
                    generateNewChoice("More than 12 months ago"),
                    generateNewChoice("Never"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["openText"],
                headline:
                    "When you think of this product type, what brands come to mind?",
            },
        ],
    },
    {
        ...generateDefaultPage(),
        questions: [
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceMulti"],
                headline:
                    "Which of the following brands have you heard of? (Select all that apply)",
                choices: [
                    generateNewChoice("Competitor 1"),
                    generateNewChoice("Competitor 2"),
                    generateNewChoice("Competitor 3"),
                    generateNewChoice("Competitor 4"),
                    generateNewChoice("Your Brand"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "When did you first hear about our brand?",
                choices: [
                    generateNewChoice("In the last month"),
                    generateNewChoice("In the last 6 months"),
                    generateNewChoice("In the last 12 months"),
                    generateNewChoice("In the last 3 years"),
                    generateNewChoice("More than 3 years ago"),
                    generateNewChoice("I’ve never heard of it"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceMulti"],
                headline:
                    "In the past 3 months, where have you seen or heard about our brand? Please select all that apply.",
                choices: [
                    generateNewChoice("Friends, family members, or colleagues"),
                    generateNewChoice("Social media"),
                    generateNewChoice(
                        "Ads in a mobile app (excluding social media)"
                    ),
                    generateNewChoice("Online video"),
                    generateNewChoice("Online search"),
                    generateNewChoice("Online news / magazine article"),
                    generateNewChoice("Printed news / magazine article"),
                    generateNewChoice("TV advertisement"),
                    generateNewChoice("Radio advertisement"),
                    generateNewChoice("Mailed advertisement"),
                    generateNewChoice("Public transportation"),
                    generateNewChoice("Billboards"),
                    generateNewChoice("Coupons"),
                    generateNewChoice("Our website"),
                    generateNewChoice("At a store (online or at the shelf)"),
                    generateNewChoice(
                        "I don’t remember hearing about or seeing advertising for this brand in the last 3 months"
                    ),
                    generateNewChoice("Other (please specify)"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "How familiar are you with our brand?",
                choices: [
                    generateNewChoice("Extremely familiar"),
                    generateNewChoice("Very familiar"),
                    generateNewChoice("Somewhat familiar"),
                    generateNewChoice("Not so familiar"),
                    generateNewChoice("Not at all familiar"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "In the past 3 months, how often did you hear people talking about our brand?",
                choices: [
                    generateNewChoice("Very often"),
                    generateNewChoice("Often"),
                    generateNewChoice("A few times"),
                    generateNewChoice("Once or twice"),
                    generateNewChoice(
                        "I haven’t heard people talking about it"
                    ),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "How would you describe your overall opinion of our brand?",
                choices: [
                    generateNewChoice("Extremely favorable"),
                    generateNewChoice("Very favorable"),
                    generateNewChoice("Somewhat favorable"),
                    generateNewChoice("Not so favorable"),
                    generateNewChoice("Not at all favorable"),
                    generateNewChoice("I have not heard of this brand"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "How has your perception of our brand changed in the past 3 months?",
                choices: [
                    generateNewChoice("Much more favorable"),
                    generateNewChoice("More favorable"),
                    generateNewChoice("Stayed the same"),
                    generateNewChoice("Less favorable"),
                    generateNewChoice("Much less favorable"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["nps"],
                headline:
                    "How likely is it that you would recommend our brand to a friend or colleague?",
                lowerLabel: "Not at all likely",
                upperLabel: "Extremely likely",
            },
        ],
    },
];

export const brandAwarenessSurveyTemplate = generateSurveyTemplate({
    name: "Brand Awareness survey",
    pages,
});
